import { useLocation } from 'react-router-dom'

/**
 * The course player serves two parents: a classroom (/classroom/:label/course/:cId)
 * and a standalone course (/courses/:label/course/:cId). These helpers are the
 * single place that knows both URL shapes.
 */
export type PlayerParentType = 'classroom' | 'standalone'

export const parentBasePath = (type: PlayerParentType, label: string) =>
	type === 'standalone' ? `/courses/${label}` : `/classroom/${label}`

export const playerBasePath = (type: PlayerParentType, label: string, cId: number | string) =>
	`${parentBasePath(type, label)}/course/${cId}`

/**
 * URL-derived parent type. Derived from the pathname (not context) on purpose:
 * FocusedView/ExpandedView wrap each unit row in a fresh CourseProvider that
 * shadows the outer context, so context-threaded parent info would be lost.
 */
export const usePlayerParentType = (): PlayerParentType => {
	const { pathname } = useLocation()
	return pathname.startsWith('/courses/') ? 'standalone' : 'classroom'
}
